module.exports = __webpack_public_path__ + "img/ncrProduct.e8c56266.png";